import { useEffect, useMemo, useState } from "react";
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css";
import EmojiPicker from "emoji-picker-react";
import InsertEmoticonIcon from "@material-ui/icons/InsertEmoticon";

import "./TextAreaMention.scss";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const TextAreaMention2 = ({
  onSubmit,
  onCancel,
  value,
  setComment,
  memberList,
  isReply,
}) => {
  const uniqueId = useMemo(
    () => `id-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    []
  );

  useEffect(() => {
    if (memberList.length > 0) {
      const whitelist_1 = memberList.map((member) => ({
        title: member,
        value: member,
        text: member,
      }));

      var input = document.querySelector("[name=mix2]"),
        tagify = new Tagify(input, {
          mode: "mix", // <--  Enable mixed-content
          pattern: /@/, // <--  Text starting with @ or # (if single, String can be used here)
          tagTextProp: "text", // <-- the default property (from whitelist item) for the text to be rendered in a tag element.
          // Array for initial interpolation, which allows only these tags to be used
          whitelist: whitelist_1,
          onChangeAfterBlur: false,
          editTags: false,
          enforceWhitelist: true,
          validate(data) {
            return !/[^a-zA-Z0-9 ]/.test(data.value);
          },
          dropdown: {
            enabled: 0,
            fuzzySearch: false,
            classname: "text-area-mention-dropdown",
            position: "text", // <-- render the suggestions list next to the typed text ("caret")
            mapValueTo: "text", // <-- similar to above "tagTextProp" setting, but for the dropdown items
            highlightFirst: true, // automatically highlights first sugegstion item in the dropdown
          },
        });

      tagify.on("keydown", function (e) {
        if (e.detail.event.key === "Enter" && !e.detail.event.shiftKey) {
          setTimeout(() => {
            document.getElementById(`reply-button-comment-${uniqueId}`).click();
          }, 200);
        }
      });

      tagify.on("input", function (e) {
        var prefix = e.detail.prefix;

        if (prefix) {
          if (prefix === "@") tagify.whitelist = whitelist_1;
        }
      });
      tagify.on("change", function (e) {
        setComment(e.detail.tagify.state.lastOriginalValueReported);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberList]);

  const [emojiPicker, setEmojiPicker] = useState(false);

  return (
    <Wrapper isReply={isReply}>
      {/* <div className="textAreaMention"> */}
      <div>
        <textarea
          id="txt-comment"
          name="mix2"
          placeholder="Share your thoughts..."
          type="text"
          value={value}
          // className="form-control form-control-2 "
        />
        <Actions>
          <InsertEmoticonIcon
            onClick={() => setEmojiPicker((prev) => !prev)}
            color="#fff"
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <CancelButton onClick={onCancel}>Cancel</CancelButton>
            <SendButton
              id={`reply-button-comment-${uniqueId}`}
              onClick={onSubmit}
              isReply={isReply}
            >
              {isReply ? <FontAwesomeIcon icon={faPaperPlane} /> : "Save"}
            </SendButton>
          </div>
        </Actions>
      </div>

      {emojiPicker && (
        <EmojiPicker
          searchDisabled="true"
          previewConfig={{ showPreview: false }}
          onEmojiClick={(e) => {
            let newValue = value;
            if (newValue.endsWith("\n")) {
              newValue = newValue.slice(0, -1);
            }
            setComment(`${newValue}${e.emoji}`);
            setEmojiPicker(false);
          }}
          height={400}
          width="100%"
        />
      )}
    </Wrapper>
  );
};

export default TextAreaMention2;

const Wrapper = styled.div`
  padding: ${(props) => (props.isReply ? "12px 0" : "0")};
  margin-left: 34px;
  border-top: ${(props) =>
    props.isReply ? "1px solid rgba(57, 61, 79, 0.35)" : "none"};

  .tagify {
    border: none;
  }

  .tagify__input {
    font-size: 13px;
    color: #fff;
    padding: 0;
  }

  .tagify__input::before {
    color: #fff;
    opacity: 0.4;
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .MuiSvgIcon-root {
    font-size: 18px;
    color: #fff;
    cursor: pointer;
  }
`;

const SendButton = styled.div`
  cursor: pointer;
  background-color: #00baff;
  color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  border-radius: 6px;
  font-size: ${(props) => (props.isReply ? "16px" : "12px")};
  padding: 0 8px;
  width: ${(props) => (props.isReply ? "48px" : "auto")};
`;

const CancelButton = styled(SendButton)`
  color: #fff;
  background-color: rgba(85, 88, 110, 0.4);
`;
